<div class="d-flex">
  <div
    class="media profile-media light-card rounded rounded-pill position-relative d-flex align-items-center pe-sm-2 me-2"
    (mouseenter)="showList(BALANCE_TYPE.BALANCE)"
    (mouseleave)="hideList(BALANCE_TYPE.BALANCE)"
    (click)="toggleList(BALANCE_TYPE.BALANCE)"
    *appShowWithPermission="PERMITTED_VIEWS.VIEW_BALANCE_NAV"
  >
    <img
      src="assets/images/icons/coin.png"
      alt=""
      class="rounded-1 d-sm-none"
      width="36"
      height="36"
    />
    <img
      src="assets/images/icons/coin.png"
      alt=""
      class="rounded-1 ms-2 d-none d-sm-inline"
      width="30"
      height="30"
    />
    <div
      class="media-body-balance d-flex flex-column justify-content-center me-2"
    >
      <span class="d-none d-sm-block mt-1">
        {{ 'profile.balance.balance' | translate }}
      </span>

      <label class="mb-0 d-sm-none fs-7">
        {{ balanceUser | number : '1.2-2' }}
      </label>
      <label class="mb-0 d-none d-sm-inline">
        {{ balanceUser | number : '1.2-2' }}
      </label>
    </div>

    <ul
      class="light-card light-card-options wallet-list position-absolute"
      [ngClass]="{'d-block': isBalanceListVisible}"
    >
      @if (otherCurrencies.length === 0) {

      <li>
        {{ 'profile.balance.notMoreWallets' | translate }}
      </li>

      } @else { @for (currency of otherCurrencies; track $index) {

      <li>{{ currency.name }} {{ currency.balance | number : '1.2-2' }}</li>

      } }
    </ul>
  </div>
  <div
    class="media profile-media light-card rounded rounded-pill position-relative d-flex align-items-center pe-sm-2"
    (mouseenter)="showList(BALANCE_TYPE.CREDIT)"
    (mouseleave)="hideList(BALANCE_TYPE.CREDIT)"
    (click)="toggleList(BALANCE_TYPE.CREDIT)"
    *appShowWithPermission="PERMITTED_VIEWS.VIEW_CREDITS_NAV"
  >
    <img
      src="assets/images/icons/wallet.png"
      alt=""
      class="rounded-1 d-sm-none"
      width="36"
      height="36"
    />
    <img
      src="assets/images/icons/wallet.png"
      alt=""
      class="rounded-1 ms-2 d-none d-sm-inline"
      width="30"
      height="30"
    />
    <div
      class="media-body-balance d-flex flex-column justify-content-center me-2"
    >
      <span class="d-none d-sm-block mt-1">
        {{ 'profile.balance.credit' | translate }}
      </span>

      <label class="mb-0 d-sm-none fs-7">
        {{ creditUser | number : '1.2-2' }}
      </label>
      <label class="mb-0 d-none d-sm-inline">
        {{ creditUser | number : '1.2-2' }}
      </label>
    </div>
    <ul
      class="light-card light-card-options wallet-list position-absolute"
      [ngClass]="{'d-block': isCreditListVisible}"
    >
      @if (otherCurrencies.length === 0) {

      <li>
        {{ 'profile.balance.notMoreWallets' | translate }}
      </li>

      } @else { @for (currency of otherCurrencies; track $index) {

      <li>{{ currency.name }} {{ currency.credit | number : '1.2-2' }}</li>

      } }
    </ul>
  </div>
</div>
